export const BankAccountStatus = {
    UNVERIFIED: 'Unverified',
    FAILED: 'Failed',
    PASSED: 'Passed'
};
